import { rootRoute } from "./tanstack_routes/__root";
import { authOtpConfirmationsNewRoute } from "./tanstack_routes/auth/otp_confirmations/new";
import { communitiesQuestionsRoute } from "./tanstack_routes/communities/$communityId/questions";
import { communitiesTemplatesRoute } from "./tanstack_routes/communities/$communityId/templates";
import { communitiesNewRoute } from "./tanstack_routes/communities/new";
import { inAppCheckoutRoute } from "./tanstack_routes/in_app_checkout";
import { invitationRoute } from "./tanstack_routes/invitation";
import { settingsProfileRoute } from "./tanstack_routes/settings/profile";
import { signInRoute } from "./tanstack_routes/sign_in";
import { signUpRoute } from "./tanstack_routes/sign_up";
import { userPasswordRoute } from "./tanstack_routes/user/password";
import { userSignInRoute } from "./tanstack_routes/user/sign_in";
import { userSignUpRoute } from "./tanstack_routes/user/sign_up";
import { usersConfirmationNewRoute } from "./tanstack_routes/users/confirmation/new";
import { usersLoginRoute } from "./tanstack_routes/users/login";
import { usersPasswordEditRoute } from "./tanstack_routes/users/password/edit";
import { usersPasswordNewRoute } from "./tanstack_routes/users/password/new";
import { usersSignInRoute } from "./tanstack_routes/users/sign_in";

export const authRouteTree = rootRoute.addChildren([
  userSignInRoute,
  userSignUpRoute,
  userPasswordRoute,
  signInRoute,
  usersSignInRoute,
  usersLoginRoute,
  signUpRoute,
  usersPasswordNewRoute,
  usersPasswordEditRoute,
  invitationRoute,
  usersConfirmationNewRoute,
  authOtpConfirmationsNewRoute,
  settingsProfileRoute,
  communitiesNewRoute,
  communitiesTemplatesRoute,
  communitiesQuestionsRoute,
  inAppCheckoutRoute,
]);
